import {ContextCodes} from "../../../pages/exploreHseContextsOldDeprecated/const/tabs";
import useAppTester from "../../../MobileMenu/hooks/useAppTester";
import {useHistory, useLocation} from "react-router-dom";
import {AuthXService} from "@brg/auth";
import {useMemo} from "react";
import { AppTester } from "../../../../supporting";

export const useGetDesignContexts = () => {

    const {
        isDeziiignMain,
        isFashionDeziiign,
        isGameDeziiign,
        isProDeziiign,
        isMediiiaUrban,
        isLabDeziiign,
    } = useAppTester();

    const {
        REACT_APP_URL_DEZIIIGN,
        REACT_APP_URL_DEZIIIGN_FASHION_COM,
        REACT_APP_URL_DEZIIIGN_GAME_COM,
        REACT_APP_URL_DEZIIIGN_PRO_COM,
        REACT_APP_URL_DEZIIIGN_URBAN_COM,
        REACT_APP_URL_DEZIIIGN_LAB_COM
    } = process.env;
    const suffix = AuthXService.isAuthenticated() ? '?shouldLogin=true&saveLoginUrl=true' : '';
    const history = useHistory()

    const links = useMemo(() => ([
        {
            id: ContextCodes.deziiignMain,
            active: isDeziiignMain,
            content: 'portfolio',
            linkTo: REACT_APP_URL_DEZIIIGN + suffix,
            action: () => {
                if (isDeziiignMain) {
                    history.push('/')
                    return;
                }
                window.open(REACT_APP_URL_DEZIIIGN + suffix, '_self')
            },

            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
        },
        {
            id: ContextCodes.fashionDeziiign,
            active: isFashionDeziiign,
            content: 'fashion',
            linkTo: REACT_APP_URL_DEZIIIGN_FASHION_COM + suffix,
            action: () => {
                if (isFashionDeziiign) {
                    history.push('/')
                    return;
                }
                window.open(REACT_APP_URL_DEZIIIGN_FASHION_COM + suffix, '_self')
            },

            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
        },
        {
            id: ContextCodes.hseVisualResearch,
            active: AppTester.isContext('urbanmediiia'),
            content: 'urban',
            linkTo: REACT_APP_URL_DEZIIIGN_URBAN_COM + suffix,
            action: () => {
                if (isMediiiaUrban) {
                    history.push('/')
                    return;
                }
                window.open(REACT_APP_URL_DEZIIIGN_URBAN_COM + suffix, '_self')
            },
            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
            hidden: false,
        },
        {
            id: ContextCodes.gameDeziiign,
            active: isGameDeziiign,
            content: 'game',
            linkTo: REACT_APP_URL_DEZIIIGN_GAME_COM + suffix,
            action: () => {
                if (isGameDeziiign) {
                    history.push('/')
                    return;
                }
                window.open(REACT_APP_URL_DEZIIIGN_GAME_COM + suffix, '_self')
            },

            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
        },
        {
            id: ContextCodes.labDeziiign,
            active: isLabDeziiign,
            content: 'lab',
            linkTo: REACT_APP_URL_DEZIIIGN_LAB_COM + suffix,
            action: () => {
                if (isLabDeziiign) {
                    history.push('/')
                    return;
                }
                window.open(REACT_APP_URL_DEZIIIGN_LAB_COM + suffix, '_self')
            },
        },
        {
            id: ContextCodes.proDeziiign,
            active: isProDeziiign,
            content: 'pro',
            linkTo: REACT_APP_URL_DEZIIIGN_PRO_COM + suffix,
            action: () => {
                if (isProDeziiign) {
                    history.push('/')
                    return;
                }
                window.open(REACT_APP_URL_DEZIIIGN_PRO_COM + suffix, '_self')
            },

            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
        },
    ]), [REACT_APP_URL_DEZIIIGN, REACT_APP_URL_DEZIIIGN_FASHION_COM, REACT_APP_URL_DEZIIIGN_GAME_COM,
        REACT_APP_URL_DEZIIIGN_PRO_COM, REACT_APP_URL_DEZIIIGN_URBAN_COM, history, isDeziiignMain, isFashionDeziiign, isGameDeziiign, isProDeziiign, suffix])

    return {
        links,
        modalSettings: {
            titleColor: isGameDeziiign ? '#FEFEFE' : '#151514',
            title: 'deziiign'
        }
    }
}import {ContextCodes} from "../../../pages/exploreHseContextsOldDeprecated/const/tabs";
import useAppTester from "../../../MobileMenu/hooks/useAppTester";
import {useHistory, useLocation} from "react-router-dom";
import {AuthXService} from "@brg/auth";
import {useMemo} from "react";
import { AppTester } from "../../../../supporting";

export const useGetDesignContexts = () => {

    const {
        isDeziiignMain,
        isFashionDeziiign,
        isGameDeziiign,
        isProDeziiign,
        isMediiiaUrban,
        isLabDeziiign,
    } = useAppTester();

    const {
        REACT_APP_URL_DEZIIIGN,
        REACT_APP_URL_DEZIIIGN_FASHION_COM,
        REACT_APP_URL_DEZIIIGN_GAME_COM,
        REACT_APP_URL_DEZIIIGN_PRO_COM,
        REACT_APP_URL_DEZIIIGN_URBAN_COM,
        REACT_APP_URL_DEZIIIGN_LAB_COM
    } = process.env;
    const suffix = AuthXService.isAuthenticated() ? '?shouldLogin=true&saveLoginUrl=true' : '';
    const history = useHistory()

    const links = useMemo(() => ([
        {
            id: ContextCodes.deziiignMain,
            active: isDeziiignMain,
            content: 'portfolio',
            linkTo: REACT_APP_URL_DEZIIIGN + suffix,
            action: () => {
                if (isDeziiignMain) {
                    history.push('/')
                    return;
                }
                window.open(REACT_APP_URL_DEZIIIGN + suffix, '_self')
            },

            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
        },
        {
            id: ContextCodes.fashionDeziiign,
            active: isFashionDeziiign,
            content: 'fashion',
            linkTo: REACT_APP_URL_DEZIIIGN_FASHION_COM + suffix,
            action: () => {
                if (isFashionDeziiign) {
                    history.push('/')
                    return;
                }
                window.open(REACT_APP_URL_DEZIIIGN_FASHION_COM + suffix, '_self')
            },

            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
        },
        {
            id: ContextCodes.hseVisualResearch,
            active: AppTester.isContext('urbanmediiia'),
            content: 'urban',
            linkTo: REACT_APP_URL_DEZIIIGN_URBAN_COM + suffix,
            action: () => {
                if (isMediiiaUrban) {
                    history.push('/')
                    return;
                }
                window.open(REACT_APP_URL_DEZIIIGN_URBAN_COM + suffix, '_self')
            },
            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
            hidden: false,
        },
        {
            id: ContextCodes.gameDeziiign,
            active: isGameDeziiign,
            content: 'game',
            linkTo: REACT_APP_URL_DEZIIIGN_GAME_COM + suffix,
            action: () => {
                if (isGameDeziiign) {
                    history.push('/')
                    return;
                }
                window.open(REACT_APP_URL_DEZIIIGN_GAME_COM + suffix, '_self')
            },

            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
        },
        {
            id: ContextCodes.labDeziiign,
            active: isLabDeziiign,
            content: 'lab',
            linkTo: REACT_APP_URL_DEZIIIGN_LAB_COM + suffix,
            action: () => {
                if (isLabDeziiign) {
                    history.push('/')
                    return;
                }
                window.open(REACT_APP_URL_DEZIIIGN_LAB_COM + suffix, '_self')
            },
        },
        {
            id: ContextCodes.proDeziiign,
            active: isProDeziiign,
            content: 'pro',
            linkTo: REACT_APP_URL_DEZIIIGN_PRO_COM + suffix,
            action: () => {
                if (isProDeziiign) {
                    history.push('/')
                    return;
                }
                window.open(REACT_APP_URL_DEZIIIGN_PRO_COM + suffix, '_self')
            },

            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
        },
    ]), [REACT_APP_URL_DEZIIIGN, REACT_APP_URL_DEZIIIGN_FASHION_COM, REACT_APP_URL_DEZIIIGN_GAME_COM,
        REACT_APP_URL_DEZIIIGN_PRO_COM, REACT_APP_URL_DEZIIIGN_URBAN_COM, history, isDeziiignMain, isFashionDeziiign, isGameDeziiign, isProDeziiign, suffix])

    return {
        links,
        modalSettings: {
            titleColor: isGameDeziiign ? '#FEFEFE' : '#151514',
            title: 'deziiign'
        }
    }
}